// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_SyncInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/franchises/sync/{id}
 *
 * No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_SyncInput {}

registerContract('SubaccountsFranchises_SyncInput', {})
